import {List, Map, Record} from 'immutable';
import ExecDashboardActions from 'actions/ExecDashboardActions';
import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';

/**
 * Note: this store holds a subset of exec data. Much of it is still in
 * ManagerDashboardStore - due to the old style capital W Widgets not really
 * strongly differentiating between exec and manager. For now, this holds
 * exec rollups.
 */
@immutableStore
class ExecDashboardStore {
  constructor() {
    this.state = Record({
      conversations: undefined,
      conversationsLoading: true,
      conversationsError: undefined,
      trendData: undefined,
      trendDataLoading: undefined,
      trendDataSuccess: undefined,
      trendDataError: undefined,
      talkListen: undefined,
      talkListenLoading: undefined,
      talkListenError: undefined,
      interchanges: undefined,
      interchangesLoading: undefined,
      interchangesError: undefined,
      // Map<TriggerRuleId, string> maps id to name.
      dashboardTriggers: Map(),
      dashboardTriggersLoading: true,
      dashboardTriggersError: false,
      topicMetrics: List(),
      topicMetricsLoading: true,
      topicMetricsError: undefined,
      // Map<TeamId, Team>
      teamsInAccount: Map(),
      teamsInAccountList: List(), // List<Team>
      teamsInAccountLoading: false,
      teamsInAccountError: false,
    })();
    this.bindActions(ExecDashboardActions);
  }

  getConversations() {
    this.setState({
      conversations: null,
      conversationsLoading: true,
      conversationsError: false,
    });
  }

  getConversationsSuccess(conversations) {
    this.setState({conversations});
  }

  getConversationsError(e) {
    console.error(e);
    this.setState({
      conversations: null,
      conversationsLoading: false,
      conversationsError: true,
    });
  }

  getTrendData() {
    this.setState({trendDataLoading: true});
  }

  getTrendDataSuccess(trendData) {
    this.setState({trendDataLoading: false, trendData});
  }

  getTrendDataError() {
    this.setState({trendDataLoading: false, trendDataError: true});
  }

  clearTrendData() {
    this.setState({trendData: null});
  }

  getInterchanges() {
    this.setState({interchangesLoading: true});
  }

  getInterchangesSuccess(interchanges) {
    this.setState({interchangesLoading: false, interchanges});
  }

  getInterchangesError(e) {
    console.error(e);
    this.setState({
      interchanges: null,
      interchangesError: true,
      interchangesLoading: false,
    });
  }

  getTalkListen() {
    this.setState({talkListenLoading: true});
  }

  getTalkListenSuccess(talkListen) {
    this.setState({
      talkListenLoading: false,
      talkListen,
    });
  }

  getTalkListenError(e) {
    console.error(e);
    this.setState({
      talkListen: null,
      talkListenError: true,
      talkListenLoading: false,
    });
  }

  getDashboardTriggers() {
    this.setState({
      dashboardTriggers: Map(),
      dashboardTriggersLoading: true,
      dashboardTriggersError: false,
    });
  }

  getDashboardTriggersSuccess(names) {
    this.setState({
      dashboardTriggers: names,
      dashboardTriggersLoading: false,
      dashboardTriggersError: false,
    });
  }

  getDashboardTriggersError(e) {
    console.error(e);
    this.setState({
      dashboardTriggers: Map(),
      dashboardTriggersLoading: false,
      dashboardTriggersError: true,
    });
  }

  getTopicMetrics() {
    this.setState({
      topicMetricsLoading: true,
      topicMetricsError: false,
    });
  }

  getTopicMetricsSuccess(topicMetrics) {
    this.setState({
      topicMetrics: topicMetrics,
      topicMetricsLoading: false,
      topicMetricsError: false,
    });
  }

  getTopicMetricsError(e) {
    console.error(e);
    this.setState({
      topicMetrics: List(),
      topicMetricsLoading: false,
      topicMetricsError: true,
    });
  }

  getTeamsInAccount() {
    this.setState({teamsInAccountLoading: true});
  }

  getTeamsInAccountSuccess(teamsInAccount) {
    const teamsInAccountList = teamsInAccount.valueSeq().toList();
    this.setState({
      teamsInAccount,
      teamsInAccountList,
      teamsInAccountLoading: false,
    });
  }

  getTeamsInAccountError() {
    this.setState({
      teamsInAccount: Map(),
      teamsInAccountError: true,
      teamsInAccountList: null,
      teamsInAccountLoading: false,
    });
  }
}
export default alt.createStore(ExecDashboardStore);
